import React, { Component, useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap'

const LogoutModal = (props) => {
    const [show, setShow] = useState(true);
    
    return (
        <Modal show={show} onHide={() => props.callback('hide')}>
            {/* <Modal.Header closeButton>
                <Modal.Title>Delete?</Modal.Title>
            </Modal.Header> */}
            <Modal.Body>Are you sure you want to logout?</Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => props.callback('hide')}>
                    Close
                </Button>
                <Button variant="danger" onClick={() => props.callback('logout')}>
                    Logout
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default LogoutModal;